import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-71" data-mp="26ll08frx8f20">
      <div className="mx-auto w-full max-w-3xl" data-id="element-72" data-mp="26k9y0ke4jfd0">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-73" data-mp="22lkcu5mugtit">
          From Doubt… to <span className="italic text-gold-dark" data-id="element-74" data-mp="2zai77mqompfg">Clinical Confidence</span>
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-75" data-mp="2ud8iyaf14jt7">
          2,400+ hours of uncertainty removed from real clinical practice.
        </p>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-76" data-mp="2la7f6gdmz4sp">
          <div className="rounded-3xl border border-red-200 bg-red-50/60 p-5" data-id="element-77" data-mp="1eux27cljnpsk">
            <p className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-wide text-red-700" data-id="element-78" data-mp="1esu2g0ulaian">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="175cl5zp767hh" />
              Before
            </p>
            <ul className="mt-4 space-y-3" data-id="element-80" data-mp="1c4gz13n2gte5">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-81" data-mp="1c2302jp9mx1b">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-600/10" data-id="element-82" data-mp="y4ehjiio81zf">
                    <XIcon className="h-3 w-3 text-red-600" aria-hidden="true" data-id="element-83" data-mp="135lpbhktd163" />
                  </span>
                  <span className="text-[14px] leading-snug text-ink-soft" data-id="element-84" data-mp="od1s0xkchnwk">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-emerald-200 bg-emerald-50/60 p-5" data-id="element-85" data-mp="ffhk55rz8tcz">
            <p className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-wide text-emerald-700" data-id="element-86" data-mp="jgtdnmdz1yqg">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-87" data-mp="5gioqow82u7x" />
              After using the protocol
            </p>
            <ul className="mt-4 space-y-3" data-id="element-88" data-mp="ah6b2x9iamvt">
              {afterItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-89" data-mp="2c5kd0jlt638y">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-600/10" data-id="element-90" data-mp="27chqgvfg7u29">
                    <CheckIcon className="h-3 w-3 text-emerald-700" aria-hidden="true" data-id="element-91" data-mp="23c7b4s5rnraq" />
                  </span>
                  <span className="text-[14px] font-medium leading-snug text-ink" data-id="element-92" data-mp="1yarqv2bexote">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCTA headline="Go from “I think so” to “I know exactly what to do.”" data-id="element-93" data-mp="2r21n77i9hbtx" />
      </div>
    </section>;
}